type Props = {
  title?: string;
  viewBox: string;
  height: number;
  width: number;
  pathD: string[];
  className?: string;
  aspectRatio?: string;
  transform?: string;
  fill?: string;
};

const SVGIcon = ({
  title,
  viewBox,
  height,
  width,
  pathD,
  aspectRatio,
  transform,
  className,
  fill,
  ...rest
}: Props) => (
  /**
   * SVG parameters and attributes
   * @param width (optional but should be set for IE 9-11) - height can be set/overridden with CSS
   * @param height (optional but should be set for IE 9-11) - width can be set/overridden with CSS
   * @param viewBox (optional but should be set for IE 9-11) - viewBox = <min-x> <min-y> <width> <height>
   * @param aspectRatio - preserveAspectRatio (default value set to 'none')
   *  - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio

    Inline SVG images have some common CSS properties.
    There's lot more SVG elements that can be styled with CSS but browser support is sporadic.

    * stroke: #color;
    * stroke-width: number (px, rem etc...);
    * fill: #color;
 */
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio={aspectRatio}
    width={width}
    height={height}
    fill={fill}
    viewBox={viewBox ? viewBox : "0 0 " + height * 2 + " " + width * 2}
    aria-labelledby={title}
  >
    {title && <title>{title}</title>}
    <g {...rest}>
      {pathD.map((paths, i) => (
        <path key={i} d={paths} />
      ))}
    </g>
  </svg>
);

export default SVGIcon;
